import React from "react";
import SEO from "../components/seo";
import LayoutPage from "../layouts";
import { graphql } from "gatsby";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const PortfolioPage = ({ data }) => {
  const { edges: projects } = data.allMdx;

  return (
    <LayoutPage>
      <SEO title="projects"> </SEO>
      <div className="portfolio">
        <h1>My Projects</h1>
        <div className="card">
          {projects.map(({ node: projects }) => (
            <div>
              <img src={projects.frontmatter.featuredImage.childImageSharp.fluid.src} alt="cover Porto"></img>
              <h2>{projects.frontmatter.title}</h2>
              <AniLink fade to={projects.frontmatter.slug} style={{color:"green"}}>Detail..</AniLink>  
            </div>
          ))}
        
        </div>
      </div>
    </LayoutPage>
  );
};
export const pageQuery = graphql`
  query MyQuery {
    allMdx {
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            slug
            featuredImage {
              publicURL
              childImageSharp {
                fluid(base64Width: 10) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default PortfolioPage;
